<template>
  <div class="tw-grid tw-grid-cols-12 tw-items-start tw-gap-5">
    <div v-for="[name, setting] in settings" :key="name" class="tw-col-span-full md:tw-col-span-6 lg:tw-col-span-4">
      <template v-if="setting.type === 'select'">
        <FormField
          type="select"
          size="small"
          :label="setting.label"
          :model-value="displayedValue(name, setting)"
          :disabled="saving"
          @update:model-value="(value) => emit('save', name, value)"
        >
          <option v-for="option in setting.options" :key="option.id" :value="option.id">
            {{ option.label }}
          </option>
        </FormField>

        <Text
          v-if="name === 'DUC_Source' && displayedValue(name, setting) === 'AUTO' && activeScalerSource"
          size="small"
          class="tw-mt-1 tw-text-state-succ"
        >
          {{ t('decimator.active_scaler_source', { source: activeScalerSource }) }}
        </Text>
      </template>

      <Checkbox
        v-else
        type="switch"
        :right-label="setting.label"
        :model-value="displayedValue(name, setting)"
        :disabled="saving"
        class="tw-px-2 tw-py-2"
        @update:model-value="(value) => emit('save', name, Boolean(value))"
      />
    </div>
  </div>
</template>

<script setup>
import { useI18n } from 'vue-i18n';

import { Checkbox, FormField, Text } from '@slideslive/fuse-kit/vue';

const { settings, pendingValues, saving, activeScalerSource } = defineProps({
  settings: { type: Array, required: true },
  pendingValues: { type: Object, required: true },
  saving: { type: Boolean, required: true },
  activeScalerSource: { type: String, default: null },
});

const emit = defineEmits(['save']);

const { t } = useI18n();

function displayedValue(name, setting) {
  return name in pendingValues ? pendingValues[name] : setting.value;
}
</script>
